import { useMutation, UseMutationOptions, useQuery, useQueryClient, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { SnapshotWithDetails } from '@app/domain-t3-interfaces';
import { Axios } from '@app/web-components';

const URL = 'snapshot';
const SNAPSHOT_QUERY_KEY = 'SNAPSHOT_QUERY_KEY';

export const snapshotKeys = {
  all: [SNAPSHOT_QUERY_KEY] as const,
};

export const useGetSnapshot = (
  id?: string,
  options?: Omit<UseQueryOptions<SnapshotWithDetails>, 'queryKey' | 'queryFn'>,
) => {
  const axios = Axios.useAxiosApi();
  return useQuery<SnapshotWithDetails, AxiosError<{ message?: string }>>({
    ...options,
    queryKey: snapshotKeys.all,
    queryFn: async () => {
      const { data } = await axios.get(`/${URL}/${id}`);
      return data;
    },
  });
};

export const useApproveSnapshot = (
  id?: string,
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, AxiosError<{ message?: string }, unknown>, void>,
    'mutationFn'
  >,
) => {
  const axios = Axios.useAxiosApi();
  const queryClient = useQueryClient();

  return useMutation<AxiosResponse<void>, AxiosError<{ message?: string }, unknown>, void>({
    ...options,
    mutationFn: async () => await axios.post<void>(`/${URL}/${id}/approve`),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: snapshotKeys.all,
      });
    },
  });
};
